import { render } from "./arrow-left.vue?vue&type=template&id=75013c42"
import script from "./arrow-left.vue?vue&type=script&lang=js"
export * from "./arrow-left.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__